import './PageLayout.css'
import React from 'react'
import { ChildrenProps } from '../../../modules/types'
import { NavSidebar } from './NavSidebar'
import { PageHeader } from './PageHeader'

export function PageLayout(props: ChildrenProps) {
  return (
    <div id="page">
      <NavSidebar/>
      <PageHeader/>
      {props.children}
    </div>
  )
}
